import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';
import ApplyPckgProdImg from '../common/image/ApplyPckgProdImg';
import CountInputBtn from '../common/button/CountInputBtn';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';

const ReqFormBrListItemBlock = styled.div`
    position: relative;
    padding-top: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #cccccc;

    .pointer {
        cursor: pointer;
    }
`;

const ReqFormBrListItemImgBlock = styled.div`
    width: 100px;
    margin-left: 36px;
    float: left;
`;

const ReqFormBrListItemTextBlock = styled.div`
    padding: 0 20px;
    float: left;
    width: 440px;
`;

const ReqFormBrListItemTitleBlock = styled.p`
    display: -webkit-box;
    height: 42px;
    font-size: 14px;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #333333;
`;

const ReqFormBrListItemOptionBlock = styled.div`
    position: absolute;
    bottom: 20px;
    color: #666666;
    font-size: 14px;
`;

const ReqFormBrListItem2PriceBlock = styled.div`
    padding: 0 20px;
    float: left;
    width: 220px;
    vertical-align: middle;
    display: table;
    height: 100px;
    text-align: center;

    .price {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        color: #999999;
        text-decoration: line-through; 
        margin-bottom: 4px;
        
    }
    
    .sale {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        color: #333333;
    }
`;

const ReqFormBrListItemCountBlock = styled.div`
    float: left;
    width : 120px;
    padding-top: 30px;
`;

const ReqFormBrListItemPriceBlock = styled.div`
    float: left;
    width: 191px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.5;
    display: table;
    height: 100px;
`;

const ReqFormBrListItemPriceInnerBlock = styled.div`
    vertical-align: middle;
    display: table-cell;
`;

const ReqFormBrListItemDelBlock = styled.div`
    margin-left : 20px;
    width : 36px;
    float: left;
    display: table;
    height: 100px;
`;

const ReqFormBrListItemDelInnerBlock = styled.div`
    vertical-align: middle;
    display: table-cell;
`;

const ReqFormBrListItemDeleteBlock = styled.button`
    ${isMobileOnly?`
    float: right;  
    margin-right: -8px;
    margin-top: -11px;
    `:`
    ''
    `};
    width: 36px;
    height: 36px;
    background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
`;


const MobileReqFormBrListItemBlock = styled.div`
    padding: 23px 0 10px;
`;

const MobileReqFormBrListItemInfoBlock = styled.div`
      height: 98px;
`;

const MobileReqFormBrListItemNameContainerBlock = styled.div`
      float: left;
      width: calc(88vw - 125px);

      .price {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        color: #999999;
        text-decoration: line-through; 
        margin-bottom: 4px;
    }
    
    .sale {
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        color: #333333;
        margin-right: 10px;
    }
`;

const MobileReqFormBrListItemNameBlock = styled.div`
    font-size: 14px;
    font-weight: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #333333;
    margin-bottom: 10px;

    max-height: 42px;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
`;

const MobileReqFormBrListItemOptionBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #666666;
    margin-bottom: 8px;
`;

const MobileReqFormBrListItemControlBlock = styled.div`
    margin-top: 10px;
    position: relative;
    padding-right: 20px;
`;


const ReqFormBrListItem = ({item, deleteItem, updateCnt}) => {

    const changeValueHandler = (value) => {
        if(updateCnt === null || updateCnt === undefined) {
            return;
        }
        updateCnt(item.prdct_id, item.opt_id, value);
/* 
        let idx = findIndex(prodCartCheckInfo, (curitem) => {
            return curitem.prdct_id === item.prdct_id;
        })

        if(idx >= 0) {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);
            checkInfo[idx].qty = value;
            dispatch(setCartCheckInfoAction(checkInfo));
        } */

    }

    const goToProduct = () => {
        let url = "/prod?prodid=" + item.prdct_id;
        var win = window.open(url, '_blank');
        win.focus();
    }

    const handleDelClick = () => {
        if(deleteItem === null || deleteItem === undefined) {
            return;
        }
        deleteItem(item.prdct_id, item.opt_id);
    }

    const isOptionDisp = () => {
        if (item.opt_nm === null || item.opt_nm === '' ||
            item.opt_nm === item.prdct_nm) {
            return 'none';
        } else {
            return 'block';
        }
    }

    return (isMobileOnly? //mobile
        <MobileReqFormBrListItemBlock>
            <MobileReqFormBrListItemInfoBlock className="clearfix">
                <div style={{float: 'left', marginRight:'10px', width:'98px'}}>
                    <ApplyPckgProdImg img={item.img}
                                id={item.prdct_id}
                                noShowDelBtn={true} width={"98px"}/>
                </div>
                <MobileReqFormBrListItemNameContainerBlock>
                    <MobileReqFormBrListItemNameBlock onClick={goToProduct} className="pointer">{item.prdct_nm}</MobileReqFormBrListItemNameBlock>
                    <MobileReqFormBrListItemOptionBlock onClick={goToProduct} className="pointer">
                    {item.opt_nm}
                    </MobileReqFormBrListItemOptionBlock>
                    <div>
                    <p className="sale f-left">{Number(item.es_opt_pirce.toFixed(1)).toLocaleString()}</p>
                    {
                        item.sale_price === item.prdct_price ? '' :
                        <p className="price f-left">{Number(item.prdct_price.toFixed(1)).toLocaleString()}</p>
                    }
                    </div>
                </MobileReqFormBrListItemNameContainerBlock>
                <ReqFormBrListItemDeleteBlock onClick={handleDelClick}/>
            </MobileReqFormBrListItemInfoBlock>
            <MobileReqFormBrListItemControlBlock className="clearfix">
                <div style={{marginLeft: '0px', position: 'absolute'}}>
                    <CountInputBtn
                    changeValueHandler={changeValueHandler}
                    num={item.qty}
                    width="32px" height="28px" />
                </div>
                <div style={{float: 'right', paddingTop: '9px'}}>
                    <SpanPckgNavPrice value={item.es_prdct_price}
                    fontSize='18px' fontWeight='500' wonFontSize='16px' float='none' />
                </div>  
                {/* <div style={{float: 'right', marginRight: '8px', paddingTop: '14px'}}>
                {
                        item.sale_price === item.prdct_price ? '' :
                        <SpanPckgNavPrice value={item.prdct_price*1*item.qty} fontSize='12px' fontWeight='500' wonFontSize='12px' float='none' isSale={true}/>
                }
                </div>   */} 
            </MobileReqFormBrListItemControlBlock>
        </MobileReqFormBrListItemBlock>
        : //desktop
        <ReqFormBrListItemBlock className="clearfix">
            <ReqFormBrListItemImgBlock>
                <ApplyPckgProdImg img={item.img}
                    id={item.prdct_id}
                    noShowDelBtn={true} />
            </ReqFormBrListItemImgBlock>
            <ReqFormBrListItemTextBlock>
                <ReqFormBrListItemTitleBlock onClick={goToProduct} className="pointer">
                    {item.prdct_nm}
                </ReqFormBrListItemTitleBlock>
                <ReqFormBrListItemOptionBlock style={{ display: isOptionDisp() }} onClick={goToProduct} className="pointer">
                    <p><span>{item.opt_nm}</span></p>
                </ReqFormBrListItemOptionBlock>
            </ReqFormBrListItemTextBlock>
            <ReqFormBrListItem2PriceBlock>
                <ReqFormBrListItemPriceInnerBlock>
            {
                item.sale_price === item.prdct_price ? '' :
                <div><p className="price">{Number(item.prdct_price.toFixed(1)).toLocaleString()}</p></div>
            }
            <div><p className="sale">{Number(item.es_opt_pirce.toFixed(1)).toLocaleString()}</p></div>
            </ReqFormBrListItemPriceInnerBlock>
            </ReqFormBrListItem2PriceBlock>
            
            <ReqFormBrListItemCountBlock>
                <CountInputBtn
                    changeValueHandler={changeValueHandler}
                    num={item.qty}
                    width="38px" height="36px" />
            </ReqFormBrListItemCountBlock>
            <ReqFormBrListItemPriceBlock>
                <ReqFormBrListItemPriceInnerBlock>
                <SpanPckgNavPrice value={item.es_prdct_price}
                    fontSize='20px' fontWeight='500' float='none' />
                    {/* {
                        item.sale_price === item.prdct_price ? '' :
                        <SpanPckgNavPrice value={item.prdct_price*1*item.qty} fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' isSale={true}/>
                    } */}
                </ReqFormBrListItemPriceInnerBlock>
            </ReqFormBrListItemPriceBlock>
            <ReqFormBrListItemDelBlock>
                <ReqFormBrListItemDelInnerBlock>
                <ReqFormBrListItemDeleteBlock onClick={handleDelClick}/>
                </ReqFormBrListItemDelInnerBlock>
            </ReqFormBrListItemDelBlock>
        </ReqFormBrListItemBlock>
    );
};

export default ReqFormBrListItem;